import axios from 'axios';
import { getUrl } from '../../MIS/Global';


const api = axios.create({
  baseURL: getUrl(),
  headers: {
    'Content-Type': 'application/json',
  },
});
 
 
export const getSumByKey=(dataArray, key)=> {
  const sum = dataArray.reduce((total, item) => {
    const value = parseFloat(item[key]);
    return total + (isNaN(value) ? 0 : value);
  }, 0);
  return sum.toFixed(2);
}

export const calculateCGST_SGST=(amount, gstPercent)=> {
  const gstTotal = (amount * gstPercent) / 100;
  const cgst = (gstTotal / 2).toFixed(2);
  const sgst = (gstTotal / 2).toFixed(2);
  return {
    cgst,
    sgst
  };
}

export const dynamicSum = (...args) => {
  const sum = args.reduce((total, val) => total + (parseFloat(val) || 0), 0);
  return sum.toFixed(2);
};

export const quotationSave = async (data) => {
  try {
    const response = await api.post('quotation/',data);    
    return response.data;
  } catch (error) {   
    // console.log(error)
    throw new Error('Something went wrong. Please try again.');
  }
};

export const quotationUpdate = async (data) => {
  try {
    const response = await api.patch('quotation/',data);    
    return response.data;
  } catch (error) {   
    // console.log(error)
    throw new Error('Something went wrong. Please try again.');
  }
};

export const quotationDelete = async (data) => {
  try {
    const queryParams = new URLSearchParams(data).toString();
    const response = await api.delete(`quotation/?${queryParams}`);    
    return response.data;
  } catch (error) {   
    // console.log(error)
    throw new Error('Something went wrong. Please try again.');
  }
};

export const getQuotations = async (data) => {
  try {
    const queryParams = new URLSearchParams(data).toString();
    const response = await api.get(`quotation/?${queryParams}`);    
    return response.data;
  } catch (error) {   
    // console.log(error)    
    throw new Error('Something went wrong. Please try again.');
  }
};




 